<template>
  <b-modal
    v-model="showModal"
    ref="modal-rrhh-discount-tracking"
    :title="title"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('hidden')"
    scrollable
  >
    <div class="table-responsive">
      <b-table
        small
        sticky-header="50vh"
        class="position-relative"
        table-class="text-nowrap"
        :items="modalData.descuentos"
        :fields="fields"
      >
        <template #cell(motivo)="data">
          <span> {{ data.value }} </span>
        </template>
        <template #cell(monto)="data">
          <span> S/. {{ data.value | currency }} </span>
        </template>
        <template #cell(estado)="data">
          <b-badge pill :variant="`light-${resolvStyleStatus(data.value)}`">
            <span> {{ $t(data.value) }} </span>
          </b-badge>
        </template>
        <template #cell(fecha)="data">
          <span> {{ data.value | myGlobal }} </span>
        </template>
      </b-table>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    modalData: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      showModal: true,
      items: [],
      fields: [
        {
          key: "motivo",
          label: this.$t("Tipo Descuento"),
          visible: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "fecha",
          label: this.$t("Fecha Descuento"),
          visible: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "monto",
          label: this.$t("Amount"),
          visible: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "estado",
          label: this.$t("Status"),
          visible: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      meses: [
        "",
        "ENERO",
        "FEBRERO",
        "MARZO",
        "ABRIL",
        "MAYO",
        "JUNIO",
        "JULIO",
        "AGOSTO",
        "SEPTIEMBRE",
        "OCTUBRE",
        "NOVIEMBRE",
        "DICIEMBRE",
      ],
    };
  },
  computed: {
    showFields() {
      return this.fields.filter((item) => item.visible);
    },
    title() {
      return `DESCUENTOS ${this.meses[this.modalData.mes]}: ${
        this.modalData.empleado
      }`;
    },
    // { "employee_id": 536, "empleado": "CARLOS JHONATHAN LLONTO JANAMPA", "descuentos_por_mes": [ { "mes": 7, "monto_total": 350, "estado": "Not Discounted", "descuentos": [ { "id": 9, "monto": 150, "estado": "Not Discounted", "fecha": "2025-07-05" }, { "id": 6, "monto": 200, "estado": "Not Discounted", "fecha": "2025-07-05" } ] }, { "mes": 8, "monto_total": 175, "estado": "Not Discounted", "descuentos": [ { "id": 10, "monto": 150, "estado": "Not Discounted", "fecha": "2025-08-05" }, { "id": 7, "monto": 25, "estado": "Not Discounted", "fecha": "2025-08-05" } ] }, { "mes": 9, "monto_total": 25, "estado": "Not Discounted", "descuentos": [ { "id": 8, "monto": 25, "estado": "Not Discounted", "fecha": "2025-09-05" } ] } ], "cc": 165, "total_anual": 550, "mes_1": 0, "mes_2": 0, "mes_3": 0, "mes_4": 0, "mes_5": 0, "mes_6": 0, "mes_7": 350, "mes_8": 175, "mes_9": 25, "mes_10": 0, "mes_11": 0, "mes_12": 0, "mes": 7 }
    // descuentosDelMes() {
    //   return this.modalData.descuentos_por_mes.map((item) => {
    //     return {
    //       empleado: this.modalData.empleado,
    //       mes: this.meses[item.mes],
    //       monto_total: item.monto_total,
    //       estado: item.estado,
    //       descuentos: item.descuentos.map((descuento) => {
    //         return {
    //           id: descuento.id,
    //           monto: descuento.monto,
    //           estado: descuento.estado,
    //           fecha: descuento.fecha,
    //         };
    //       }),
    //     };
    //   });
    // },
  },
  methods: {
    resolvStyleStatus(status) {
      let val = "success";
      switch (status) {
        case "Not Discounted":
          val = "warning";
          break;
        case "Discounted":
          val = "success";
          break;
        default:
          break;
      }
      return val;
    },
  },
};
</script>

<style scoped>
.py-1s {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>